module.exports = __webpack_public_path__ + "img/tierschutzpartei-logo.8eb78700.svg";